import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { SwModalframeComponent } from '../sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwTreeService } from 'src/app/librarys/components/basic-components/sw-tree/sw-tree.service';
declare var $: any;

@Component({
  selector: 'app-sw-address-book',
  templateUrl: './sw-address-book.component.html',
  styleUrls: ['./sw-address-book.component.css']
})
export class SwAddressBookComponent implements OnInit {

  /**
   * 动态创建组件传入的参数, 要含有 userId 这个数组,比如： 
   * {
   * userId:ids,  //数组，多选要回显的id
   * type:1,      //类型，是根据 1--角色岗位组织 来选择还是在 2--所有用户 中选择
   * required:2,  //是 2-->必填项 还是 1--不必选 ,默认必填
   * radio:false,  //是 true--单选 还是 false--多选，默认多选
   * headerLogo:"审批人区域"
   * }
   */
  @Input() param 

  /**
   * 动态创建组件的抛出事件
   */
  @Output() callback = new EventEmitter(); 

  /**
   * 模态框
   * @ignore
   */
  @ViewChild('userModal') userModal: SwModalframeComponent; 

  /**
   * 组件是单选还是多选,默认多选
   * @ignore
   */
  radio:boolean = false

  /**
   * 选中的用户
   * @ignore
   */
  selectedUsers:any[] =[] 

  /**
   * 所有的用户
   * @ignore
   */
  allUsers:any[] =[] 

  /**
   * 多选-要回显的勾选的用户id数组
   * @ignore
   */
  checkedUser:any[] = []

  /**
   * 单选--要回显的勾选的用户id
   * @ignore
   */
  keySelected:string = ""

  /**
   * 树组件上面的搜索内容
   * @ignore
   */
  searchValue:string = ""

  /**
   * 模态框标题，默认是 "审批人区域"
   * @ignore
   */
  headerLogo:string = "通讯录"

  /**
   * 模态框选值是否是必填项，默认是2-->必填项，不选择用户点击确定会提示，如果是1-->不是必填，那么不选用户也可以点击确定
   * @ignore
   */
  required:number = 2

  /**
   * 搜索结果
   * @ignore
   */
  searchList:any[] = []

  /**
   * 组件类型，1：根据角色，岗位，组织查询用户 ； 2：直接显示所有用户，不需查询， 默认为1
   * @ignore
   */
  type:number = 1

  /**
   * 当 type=2 根据 所有用户 选择时，这就是左侧 所有用户 列表信息
   * @ignore
   */
  type2UserList:any[] = []

  /**
   * 当 type=1 根据 角色岗位组织 选择时，这就是左侧 角色岗位组织 列表信息
   * @ignore
   */
  type1RootList:any[] = []

  /**
   * 当 type=1 根据 角色岗位组织 选择时，这就是左侧 角色岗位组织 列表信息
   * @ignore
   */
  type1JobOrRoleList:any[] = []

  /**
   * 当 type=1 根据 角色岗位组织 选择时，这就是左侧 用户 列表信息
   * @ignore
   */
  type1UserList:any[] = []

  /**
   * 当 type=1 根据 角色岗位组织 选择时，是点击的哪个根节点分类选择的
   * @ignore
   */
  typeRoot:any = null  

  /**
   * 当 type=1 根据 角色岗位组织 选择时，是点击的是具体哪个 角色岗位组织
   * @ignore
   */
  checkedJobOrRole:any = null

  constructor(
    private systemId:SystemIdService,
    private bdpService: BdpService, //请求服务
    private el:ElementRef,
    private renderer2:Renderer2,
    private http: SwHttpClientService, //http请求
    private box: SwMassageBoxService,  //消息提示服务
    private swTreeService:SwTreeService
    ) { }

  ngOnInit() {
    // 看是否有回显的id
    if(this.param.userId){
      this.checkedUser = JSON.parse(JSON.stringify(this.param.userId))
    }
    // 看类型是否指定
    if(this.param.type){
      this.type = JSON.parse(JSON.stringify(this.param.type))
    }
    //看是否是必填
    if(this.param.required){
      this.required = this.param.required
    }
    //模态框标题
    if(this.param.headerLogo){
      this.headerLogo = this.param.headerLogo
    }
    //组件是否多选
    this.radio = this.param.radio || false
    //如果是单选，回显就用 keySelected
    if(this.radio){
      this.keySelected = this.checkedUser[0]
      
    }

    // //获取所有用户
    this.getUser()
  }

  //首次获取所有用户
  getUser(){
    //获取用户
    var Check = $("input[name='user']");
    //然后全部取消选择
    Check.prop("checked", false)
    let param1 = {systemId: this.systemId.getSystemId()}
    this.bdpService.getUserService().queryList(param1).subscribe( //查询用户
      data => {
        if (data["code"] == 200) {
          let arr1 = []
          let result = data["data"]
          result.forEach(user => {
            //if(user.status){
              // 查询所有用户，默认没有用户被选中
              arr1.push({id:user.userId,text:user.displayName,pid:'999',checked:false,dataType:'user'})
            //}
          });
          //所有的用户
          this.allUsers = arr1
          let allChecked = true  //假设所有人都选中了
          // 根据回显的 this.checkedUser id数组来确定 选中的用户
          this.allUsers.forEach(user=>{
            let checked = this.checkedUser.indexOf(user.id) != -1
            user.checked = checked
            if(!checked){
              //只要有一个没选中，全选按钮就不用选中
              allChecked = false
            }
          })
          this.selectedUsers = this.allUsers.filter(v=>v.checked)
          
          if(this.type == 2){
            //如果直接显示所有用户，不需要根据角色岗位组织去查询
            this.type2UserList = JSON.parse(JSON.stringify(this.allUsers))
            //如果回显时所有用户都已经都选了，就将全选按钮勾选上
            if(allChecked && this.type2UserList.length){
              setTimeout(() => {
                if(!this.radio){
                  let allInput = document.getElementById('all') as HTMLInputElement
                  allInput.checked = allChecked
                }
              }, 20);
            }
          } else {
            //根据角色岗位组织去查询
            if(this.param.iszz)//如果只显示组织
            {
              this.type1RootList = [
            
                {id:'2',text:'按组织选择',pid:'0',root:true},
            ] 
            }
            else{
              this.type1RootList = [
                {id:'1',text:'按角色选择',pid:'0',root:true},
                {id:'2',text:'按组织选择',pid:'0',root:true},
                {id:'3',text:'按岗位选择',pid:'0',root:true}] 
            }
        
          }
        }
      }
    )
  }

  /**
   * 将处理人取最后两位展示
   * @ignore
   */
  getFinalName(name:string){
    if(name){
      let newName = name.substring(name.length-2,name.length)
      return newName
    }
  }

  /**
   * 根据所有用户进行选择时
   * @param event 
   * @param user 
   * @param i 
   */
  type2Select(event,user, i){
    if(this.radio){
      // 单选，单选框不能取消勾选
      if(event.target.checked){
        //如果是勾选，就将其他选中都删除，只能勾选这一个
        this.selectedUsers = [user]
      }
    } else {
      // 多选
      if(event.target.checked){
        //如果是勾选
        // 看右侧有没有该用户，有就不做什么，没有就添加
        let index = this.selectedUsers.findIndex(item => item.id == user.id)
        if(index == -1){
          // 如果没有该用户，就加到右侧
          user.checked = true
          this.selectedUsers.push(user)
        }
      } else {
        //如果是取消勾选
        // 看右侧有没有该用户，有的话就要删除，没有就不做什么
        let index = this.selectedUsers.findIndex(item => item.id == user.id)
        if(index != -1){
          // 如果有该用户，从中删除
          this.selectedUsers.splice(index,1)
        }
      }
    }
    this.checkedUser = this.selectedUsers.map(v=>v.id)
    //看需不需要勾选或取消勾选全选按钮
    if(this.type == 1){
      if(!this.radio){
        let allChecked = this.type1UserList.every(v=>this.checkedUser.includes(v.id))
        let allInput = document.getElementById('all') as HTMLInputElement
        allInput.checked = allChecked
      }
    } else if(this.type == 2){
      if(!this.radio){
        let allChecked = this.type2UserList.every(v=>this.checkedUser.includes(v.id))
        let allInput = document.getElementById('all') as HTMLInputElement
        allInput.checked = allChecked
      }
    }
    
  }

  /**
   * 根据角色岗位组织选择时，点击根节点时
   * @param root 
   */
  selectType(root){
    //获取根节点分类
    this.typeRoot = JSON.parse(JSON.stringify(root))
    if(root.id == '1'){
      //如果是按角色选择
      // 获取角色
      this.getRole()
    } else if(root.id == '2'){
      //如果是按组织选择
      // 获取组织
      this.getDepartment()
    } else if(root.id == '3'){
      //如果是按岗位选择
      // 获取岗位
      this.getPosition()
    }
  }

  /**
   * 选择 角色，组织 或岗位 时
   * @param jobOrRole 
   */
  selectJobOrRole(jobOrRole){
    this.checkedJobOrRole = JSON.parse(JSON.stringify(jobOrRole))
    if(this.typeRoot['id'] == '1'){
      //点击了某个角色，重新查询用户，先要根据选中的用户数组，将选中的id数组更新
      this.checkedUser = this.selectedUsers.map(v=>v.id)
      this.onVotedRole(jobOrRole)
    } else if(this.typeRoot['id'] == '2'){
      //点击了某个组织，重新查询用户，先要根据选中的用户数组，将选中的id数组更新
      this.checkedUser = this.selectedUsers.map(v=>v.id)
      this.onVotedDepartment(jobOrRole)

    } else if(this.typeRoot['id'] == '3'){
      //点击了某个岗位，重新查询用户，先要根据选中的用户数组，将选中的id数组更新
      this.checkedUser = this.selectedUsers.map(v=>v.id)
      this.onVotedPosition(jobOrRole)

    }
  }

  /**
   * 点击展开树节点
   * @param node 
   */
  expand(node){
    node.expanded = true
  }

  /**
   * 点击展开树节点
   * @param node 
   */
  close(node){
    node.expanded = false
  }

  /**
   * type=1时，点击返回根节点
   */
  returnRoot(){
    this.typeRoot = null //将选中的根节点清空
    this.checkedJobOrRole = null  //将之前选中的树节点清空
    this.type1UserList = []  //将之前根据树节点得到的用户数据清空
    this.type1JobOrRoleList = []  //将树节点数据清空
  }

  /**
   * type=1时，点击返回对应的 角色 组织 岗位 树节点
   */
  returnJobOrRole(){

    if(this.typeRoot.id == '1'){
      //如果是按角色选择
      // 获取角色
      this.getRole(this.checkedJobOrRole.key)
    } else if(this.typeRoot.id == '2'){
      //如果是按组织选择
      // 获取组织
      this.getDepartment(this.checkedJobOrRole.key)
    } else if(this.typeRoot.id == '3'){
      //如果是按岗位选择
      // 获取岗位
      this.getPosition(this.checkedJobOrRole.key)
    }
    this.checkedJobOrRole = null  //将之前选中的树节点清空
    this.type1UserList = []  //将根据树节点得到的用户数据清空
  }
  
  /**
   * 多选时，搜索框内部勾选或取消勾选
   * @param event 
   * @param data 
   */
  checKboxChange(event,data) {
    //判读是否选中
    if (event.target.checked) {
      // 将据的状态修改
      data.checked = true
      // 将之加到右侧已选中的数组中
      this.selectedUsers.push(data)
    } else {
      //如果是取消 则在选择数组中 删除掉数据
      let index2 = this.selectedUsers.findIndex(item => item.id == data.id)
      if( index2 != -1){  
        this.selectedUsers.splice(index2, 1);
      }
    }
    //刷新树的选中id
    this.checkedUser = this.selectedUsers.map(v=>v.id)
    //将搜索内容和搜索结果清空
    this.searchValue = ""
    this.searchList = []
  }

  /**
   * 单选时，搜索框内部勾选,单选框不能取消勾选
   * @param event 
   * @param user 
   * @param i 
   */
  radioChange(event,user,i){
    //判读是否选中
    if (event.target.checked) {
      // 如果是选中，就讲其他选中项删除
      user.checked = true
      // 将之加到右侧已选中的数组中
      this.selectedUsers = [user]
    } 
    //刷新树的选中id
    this.checkedUser = this.selectedUsers.map(v=>v.id)
    //将搜索内容和搜索结果清空
    this.searchValue = ""
    this.searchList = []
  }

  // 点击全选框
  all(event){
    // 点击全选框，
    if (event.target.checked) {
      //如果是全选
      if(this.type == 1 && !this.radio){
        //如果是按 角色组织岗位的多选 情况
        this.type1UserList.forEach(v=>{
          // 看右侧有没有该用户
          let index = this.selectedUsers.findIndex(item => item.id == v.id)
          if(index == -1){
            // 如果没有该用户，就加到右侧
            v.checked = true
            this.selectedUsers.push(v)
          }
        })
      } else if(this.type == 2 && !this.radio){
        //如果是按 所有用户 的多选 情况
        this.type2UserList.forEach(v=>{
          // 看右侧有没有该用户
          let index = this.selectedUsers.findIndex(item => item.id == v.id)
          if(index == -1){
            // 如果没有该用户，就加到右侧
            v.checked = true
            this.selectedUsers.push(v)
          }
        })
      }
    } else {
      //如果是取消全选
      if(this.type == 1 && !this.radio){
        //如果是按 角色组织岗位的多选 情况
        this.type1UserList.forEach(v=>{
          // 看右侧有没有该用户
          let index = this.selectedUsers.findIndex(item => item.id == v.id)
          if(index != -1){
            // 如果有该用户，从中删除
            this.selectedUsers.splice(index,1)
          }
        })
      } else if(this.type == 2 && !this.radio){
        //如果是按 所有用户 的多选 情况
        this.type2UserList.forEach(v=>{
          // 看右侧有没有该用户
          let index = this.selectedUsers.findIndex(item => item.id == v.id)
          if(index != -1){
            // 如果有该用户，从中删除
            this.selectedUsers.splice(index,1)
          }
        })
      }
    }
    //刷新树的选中id
    this.checkedUser = this.selectedUsers.map(v=>v.id)
  }

  //获取左侧角色树
  getRole(keySelected?:string){
    let param2 = {systemId: this.systemId.getSystemId()}
    this.bdpService.getRoleService().queryList(param2).subscribe(  //请求角色数据
      data => {
        if (data["code"] == 200) {
          let arr1 = [];
          //获取到的数组中没有id text pid字段,所以要处理一下数据,转化为树组件所需要的格式
          data["data"]["records"].forEach(e => {
            arr1.push({ id: e.roleId, text: e.roleName, pid: 'Yiji',isAdmin:e.isAdmin,dataType:'role' })
          });
          this.type1JobOrRoleList = this.swTreeService.toNodeOptions(arr1, keySelected, 'id', 'pid', 'text', "", [], [], 1, false, false,[],"","",false);
        }
      }
    )
  }

  //获取左侧岗位树
  getPosition(keySelected?:string){
    let param3 = {systemId: this.systemId.getSystemId() }
    this.bdpService.getPositionService().queryList(param3).subscribe(data => {
      if (data["code"] == 200) {
        //数组中自带了 id text pid字段,不需要处理
        let list = data["data"]["records"]
        list.forEach(v => {
          v['dataType'] = 'position'
        });
        this.type1JobOrRoleList = this.swTreeService.toNodeOptions(list, keySelected, 'id', 'pid', 'text', "", [], [], 1, false, false,[],"","",false);
      }
    });
  }

  //获取左侧组织树
  getDepartment(keySelected?:string) {
    let systemId = this.systemId.getSystemId()//拿系统id
    let Params =  { systemId: systemId } //取所有组织管理数据
    this.bdpService.getDepartmentService().queryList(Params).subscribe(data => {
      if (data["code"] == 200) { //请求成功
        //数组中自带了 id text pid字段,不需要处理
        let list = data["data"]["records"]
        list.forEach(v => {
          v['dataType'] = 'department'
        });
        this.type1JobOrRoleList = this.swTreeService.toNodeOptions(list, keySelected, 'id', 'pid', 'text', "", [], [], 1, false, false,[],"","",false);
      }
    });
  }
 
  //组织树的选中结果
  onVotedDepartment(event){
    //根据组织查询用户
    let param = { "param": { pageSize: 0,systemId:this.systemId.getSystemId() }, "organizeId": event.key,lazy:false, "entity":{} }
    this.bdpService.getCommonService().queryUserByOrganizeId(param).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]["records"]
        let allChecked = true  //假设查询的用户全都都是勾选的
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,pid:'999',checked:checked,dataType:'user'})
            if(!checked){
              //只要有一个没选中，全选按钮就不用选中
              allChecked = false
            }
          }
        });
        // 将用户数据赋值给树
        this.type1UserList = temp
        //如果回显时所有用户都已经都选了，就将全选按钮勾选上
        if(this.type1UserList.length){
          setTimeout(() => {
            if(!this.radio){
              let allInput = document.getElementById('all') as HTMLInputElement
              allInput.checked = allChecked
            }
          }, 0);
        } else {
          this.box.danger('该节点没有关联到用户')
        }
      }
    })
  }

  //角色树的选中结果
  onVotedRole(event){
    //根据角色查询用户
    let param = { "param": { pageSize: 0 },  "entity": {"roleId": event.key,systemId:this.systemId.getSystemId()} }
    this.bdpService.getUserService().queryUserByRoleId(event.key,this.systemId.getSystemId()).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]
        let allChecked = true  //假设查询的用户全都都是勾选的
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,pid:'999',checked:checked,dataType:'user'})
            if(!checked){
              //只要有一个没选中，全选按钮就不用选中
              allChecked = false
            }
          }
        });
        // 将用户数据赋值给树
        this.type1UserList = temp
        //如果回显时所有用户都已经都选了，就将全选按钮勾选上
        if(this.type1UserList.length){
          setTimeout(() => {
            if(!this.radio){
              let allInput = document.getElementById('all') as HTMLInputElement
              allInput.checked = allChecked
            }
          }, 0);
        } else {
          this.box.danger('该节点没有关联到用户')
        }
      }
    })
    
  }

  //岗位树的选中结果
  onVotedPosition(event){
    let param = { "param": { pageSize: 0,systemId:this.systemId.getSystemId() }, "positionId": event.key, "entity":{}}
    this.bdpService.getUserService().queryUserByPositionId(param).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]["records"]
        let allChecked = true  //假设查询的用户全都都是勾选的
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,pid:'999',checked:checked,dataType:'user'})
            if(!checked){
              //只要有一个没选中，全选按钮就不用选中
              allChecked = false
            }
          }
        });
        // 将用户数据赋值给树
        this.type1UserList = temp
        //如果回显时所有用户都已经都选了，就将全选按钮勾选上
        if(this.type1UserList.length){
          setTimeout(() => {
            if(!this.radio){
              let allInput = document.getElementById('all') as HTMLInputElement
              allInput.checked = allChecked
            }
          }, 0);
        } else {
          this.box.danger('该节点没有关联到用户')
        }
      }
    })
    
  }

  /**
   * 单选时 点击搜索结果
   * @param user 
   */
  checkSearch(user){
    user.checked = true
    this.selectedUsers = [user]
    this.keySelected = this.selectedUsers[0]['id']
  }

  //点击指定执行人模态框的确认按钮
  sureOperator(){
    this.checkedUser = this.selectedUsers.map(v=>v.id)
    if(this.required == 2){
      //如果是必填项
      if(this.checkedUser.length){
        this.userModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
        this.callback.emit(this.checkedUser)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
      }else {
        this.box.danger('请选择用户')
      }
    } else if(this.required == 1){
      this.userModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
      this.callback.emit(this.checkedUser)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
    }
  }

  //点击关闭模态框
  closeOperatorModal(){
    this.userModal.toggle() //关闭模态框
    this.callback.emit(false)  //抛出false, 只销毁组件,什么都不做
  }

  //enter事件
  keydown(event) {
    this.searchValue = event.target.value
    this.search()
  }
 
  //点击搜索
  search(){
    if(this.searchValue){  //为true的时候展示用户
      this.searchList = this.allUsers.filter(item=>item.text.indexOf(this.searchValue)>=0)
    } else{
      // 没有搜索内容
      this.searchList = []
    }
  }

  // 删除某个已选中的用户
  clearOneUser(data){
    // 删除某个已选中的用户
    let index = this.selectedUsers.findIndex(item => item.id == data.id)
    if(index != -1){
      // 如果有该用户，从中删除
      this.selectedUsers.splice(index,1)
      // 刷新选中的id
      this.checkedUser = this.selectedUsers.map(v=>v.id)
      
      this.keySelected = ""
    }
  }

  // 意见清空所有选中用户
  clearAll(){
    this.selectedUsers = []
    this.checkedUser = []
    this.keySelected = ""
  }
}
